import React from "react";
import { Header, About, Skills, Work, Testimonial, Footer, Navbar } from "./container";
import './App.scss';

const App = () => {
    return (
        <div className="app">
            <Navbar />
            <Header />
            <About />
            <Skills />
            <Work />
            <Testimonial />
            <Footer />
        </div>
    );
}

export default App;